import { EventDate } from './EventDate';
import { PortCall } from './PortCall';
import { CargoOperation } from './CargoOperation';
import { RotationTreeEnum } from '../../enums/rotationTreeEnum';
import { IRotationNode } from './IRotationNode';
import { ReportLocationEnum } from '../../enums/reportLocationEnum';
import { MoveActionMsg } from './ActionMsg';

export class BerthCall implements IRotationNode {
    constructor(
        berthCallId: number | null,
        cargoOperationArray: CargoOperation[],
        berthId: number | null,
        voyageNumber: string,
        name: string | null,
        arrivalDate: EventDate | null,
        departureDate: EventDate | null,
        portCall: PortCall | null,
        nodeStatus: string,
        isDeleted: boolean,
        addedDeletedBerthCall: boolean,
        isLocked: boolean,
        isMoved: boolean,
        isMovedTo: boolean,
        isSelected: boolean,
        deletedIconTooltipText: string | null,
        moveToBerthCallId: number | null,
        aolDate: Date | null,
        reportLocation: ReportLocationEnum,
        manualBerthSequenceNumber: number | null,
        imosPortFunction: string | null,
        portClusterInitialPortId: number | null,
        portClusterInitialPortName: string | null,
        delayInputWarningText: string | null,
        firstTimeInPortCall: Date | null
    ) {
        this.berthCallId = berthCallId;
        this.cargoOperationArray = cargoOperationArray;
        this.berthId = berthId;
        this.voyageNumber = voyageNumber;
        this.name = name;
        this.arrivalDate = arrivalDate;
        this.departureDate = departureDate;
        this.portCall = portCall;
        this.nodeStatus = nodeStatus;
        this.isDeleted = isDeleted;
        this.addedDeletedBerthCall = addedDeletedBerthCall;
        this.isLocked = isLocked;
        this.isMoved = isMoved;
        this.isMovedTo = isMovedTo;
        this.isSelected = isSelected;
        this.isExpanded = false;
        this.deletedIconTooltipText = deletedIconTooltipText;
        this.moveToBerthCallId = moveToBerthCallId;
        this.aolDate = aolDate;
        this.id = this.berthCallId;
        this.type = RotationTreeEnum.BerthCall;
        this.reportLocation = reportLocation;
        this.manualBerthSequenceNumber = manualBerthSequenceNumber;
        this.imosPortFunction = imosPortFunction;
        this.movedFromClicked = false;
        this.actionMsg = new MoveActionMsg(false, null, false, null, null, null);
        this.timezoneWarningText = null;
        this.portClusterInitialPortId = portClusterInitialPortId;
        this.portClusterInitialPortName = portClusterInitialPortName;
        this.delayInputWarningText = delayInputWarningText;
        this.firstTimeInPortCall = firstTimeInPortCall;
    }

    berthCallId: number | null;
    cargoOperationArray: CargoOperation[];
    id: number | null;
    berthId: number | null;
    voyageNumber: string;
    name: string | null;
    arrivalDate: EventDate | null;
    departureDate: EventDate | null;
    isExpanded: boolean;
    type: RotationTreeEnum;
    portCall: PortCall | null;
    nodeStatus: string;
    isDeleted: boolean;
    addedDeletedBerthCall: boolean;
    actionMsg: MoveActionMsg;
    isLocked: boolean;
    isMoved: boolean;
    isMovedTo: boolean;
    isSelected: boolean;
    deletedIconTooltipText: string | null;
    moveToBerthCallId: number | null;
    aolDate: Date | null;
    reportLocation: ReportLocationEnum;
    manualBerthSequenceNumber: number | null;
    movedFromClicked: boolean;
    imosPortFunction: string | null;
    timezoneWarningText: string | null;
    portClusterInitialPortId: number | null;
    portClusterInitialPortName: string | null;
    delayInputWarningText: string | null;
    firstTimeInPortCall: Date | null;
}
